var author = require('../module/author')
var scroll = require('../module/scroll')
var tab = require('../module/tab')
scroll()
author()
tab()




